module.exports = {"init":"بارگزاری ...","no-found-related":"%{link} مرتبط پیدا نشد.","please-contact":"لطفاً با %{user} اطلاع دهید تا اضافه کند.","init-issue":"شروع نظرات","leave-a-comment":"نظرتان را بنویسید","preview":"پیش‌نمایش","edit":"ویرایش","comment":"ثبت","support-markdown":"پشتیبانی از مارک‌داون","login-with-github":"ورود با گیت‌هاب","first-comment-person":"اولین نظر را شما بنویسید!","commented":" - ","load-more":"نظرات بیشتر","counts":"%{counts} نظر |||| %{counts} نظر","sort-asc":"مرتب‌سازی از قدیمی‌ترین","sort-desc":"مرتب‌سازی از جدیدترین","logout":"خروج","anonymous":"بی‌نام"}


//////////////////
// WEBPACK FOOTER
// ./i18n/fa.json
// module id = 271
// module chunks = 0